import { Role } from '@/types'

// Mirrors aria-web/src/backend_service/schemas/api/enterprise.py — keep in sync.
// Use these helpers (not literal role comparisons) so adding a future admin-level
// or billable role needs only a single update here.

const ADMIN_ROLE_VALUES: ReadonlySet<string> = new Set<string>(['admin', 'superadmin', 'it_admin'])

const BILLABLE_ROLE_VALUES: ReadonlySet<string> = new Set<string>(['admin', 'superadmin', 'member'])

export const isAdminRole = (role: Role | string | null | undefined): boolean => {
  if (!role) return false
  return ADMIN_ROLE_VALUES.has(role.toString().toLowerCase())
}

export const isBillableRole = (role: Role | string | null | undefined): boolean => {
  if (!role) return false
  return BILLABLE_ROLE_VALUES.has(role.toString().toLowerCase())
}
